var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import Title from '../../../atoms/Title';
import { VerticalGap } from '../../../atoms/Gap/Gap';
import Desc from '../../../atoms/Desc';
import { neutralDay } from '@teamsparta/design-system';
import CtaBtn from '../../../atoms/CtaBtn';
import { checkNewPassword } from '../../../../businessLogics';
import NewPasswordForm from '../../../molecules/NewPasswordForm/NewPasswordForm';
import { BottomContents, MainContents } from '../../../../styles/_common.style';
import { useIsMobile } from '../../../../businessLogics/hooks';
import { useChangePassword } from '../../../../businessLogics/apis';
var ChangePasswordEnter = function () {
    var _a = useState(''), password = _a[0], setPassword = _a[1];
    var _b = useState(''), passwordDoubleCheck = _b[0], setPasswordDoubleCheck = _b[1];
    var _c = useState(false), isCtaClickable = _c[0], setIsCtaClickable = _c[1];
    var _d = useState(null), passwordWarning = _d[0], setPasswordWarning = _d[1];
    var isMobile = useIsMobile();
    useEffect(function () {
        if (password.length >= 6 && passwordDoubleCheck.length >= 6) {
            setIsCtaClickable(true);
        }
    }, [password, passwordDoubleCheck]);
    var changePassword = useChangePassword();
    var onClickCta = function () {
        if (checkNewPassword(password, passwordDoubleCheck, setPasswordWarning)) {
            changePassword.mutate({ password: password });
        }
    };
    return (_jsxs(_Fragment, { children: [_jsxs(MainContents, __assign({ paddingTop: 70 }, { children: [_jsx(Title, { children: "\uBE44\uBC00\uBC88\uD638 \uBCC0\uACBD\uD558\uAE30" }), _jsx(VerticalGap, { size: isMobile ? 8 : 12 }), _jsx(Desc, { children: "\uC0C8\uB85C\uC6B4 \uBE44\uBC00\uBC88\uD638\uB97C \uC785\uB825\uD574 \uC8FC\uC138\uC694." }), _jsx(VerticalGap, { size: isMobile ? 20 : 40 }), _jsx(NewPasswordForm, { password: password, setPassword: setPassword, passwordDoubleCheck: passwordDoubleCheck, setPasswordDoubleCheck: setPasswordDoubleCheck, passwordWarning: passwordWarning, onClickCta: onClickCta }), !isMobile && (_jsxs(_Fragment, { children: [_jsx(VerticalGap, { size: 40 }), _jsx(CtaBtn, __assign({ bgColor: isCtaClickable ? neutralDay.gray100 : '#1416174d', color: neutralDay.white, onClickAction: onClickCta, isInactive: !isCtaClickable }, { children: "\uBE44\uBC00\uBC88\uD638 \uBCC0\uACBD\uD558\uAE30" }))] }))] })), isMobile && (_jsx(BottomContents, { children: _jsx(CtaBtn, __assign({ bgColor: isCtaClickable ? neutralDay.gray100 : '#1416174d', color: neutralDay.white, onClickAction: onClickCta, isInactive: !isCtaClickable }, { children: "\uBE44\uBC00\uBC88\uD638 \uBCC0\uACBD\uD558\uAE30" })) }))] }));
};
export default ChangePasswordEnter;
//# sourceMappingURL=ChangePasswordEnter.js.map